import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "register-wrap" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title" }, "免费注册", -1)
const _hoisted_5 = { class: "reg-box" }
const _hoisted_6 = { class: "reg-list" }
const _hoisted_7 = { class: "reg-item" }
const _hoisted_8 = { for: "userName" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "key" }, "用户名", -1)
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = { class: "reg-item" }
const _hoisted_12 = { for: "companyName" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "key" }, "公司名", -1)
const _hoisted_14 = {
  key: 0,
  class: "error"
}
const _hoisted_15 = { class: "reg-item" }
const _hoisted_16 = { for: "password" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "key" }, "密码", -1)
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "reg-item" }
const _hoisted_20 = { for: "phone" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "key" }, "手机号", -1)
const _hoisted_22 = {
  key: 0,
  class: "error"
}
const _hoisted_23 = { class: "reg-item" }
const _hoisted_24 = { for: "validCode" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "key" }, "验证码", -1)
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "reg-item" }
const _hoisted_28 = { for: "inviteCode" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "key" }, "邀请码", -1)
const _hoisted_30 = { class: "register-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "userName",
                  class: "value",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ajaxData.userName = $event)),
                  placeholder: "请输入用户名",
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkVal('userName')))
                }, null, 544), [
                  [_vModelText, _ctx.ajaxData.userName]
                ])
              ]),
              (_ctx.errorData.userName)
                ? (_openBlock(), _createBlock("span", _hoisted_10, "请输入用户名"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "companyName",
                  class: "value",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ajaxData.companyName = $event)),
                  placeholder: "请输入公司名",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkVal('companyName'))),
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkVal('companyName')))
                }, null, 544), [
                  [_vModelText, _ctx.ajaxData.companyName]
                ])
              ]),
              (_ctx.errorData.companyName)
                ? (_openBlock(), _createBlock("span", _hoisted_14, "请输入公司名"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "password",
                  class: "value",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ajaxData.password = $event)),
                  placeholder: "6-16位密码，区分大小写",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkVal('password'))),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.checkVal('password')))
                }, null, 544), [
                  [_vModelText, _ctx.ajaxData.password]
                ])
              ]),
              (_ctx.errorData.password)
                ? (_openBlock(), _createBlock("span", _hoisted_18, "密码应在6-16位之间"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createVNode("input", {
                  type: "tel",
                  id: "phone",
                  class: "value",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.ajaxData.phone = $event)),
                  placeholder: "请输入手机号",
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkVal('phone'))),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.checkVal('phone'))),
                  maxlength: "11"
                }, null, 544), [
                  [_vModelText, _ctx.ajaxData.phone]
                ])
              ]),
              (_ctx.errorData.phone)
                ? (_openBlock(), _createBlock("span", _hoisted_22, "请输入正确手机号"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("label", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "validCode",
                  class: "value",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.ajaxData.validCode = $event)),
                  placeholder: "请输入验证码",
                  onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkVal('validCode'))),
                  onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkVal('validCode')))
                }, null, 544), [
                  [_vModelText, _ctx.ajaxData.validCode]
                ]),
                _createVNode("span", {
                  id: "sendMsgBtn",
                  class: [_ctx.setCodeLeftTime > 0 ? 'wait' : ''],
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.sendMsgCode && _ctx.sendMsgCode(...args)))
                }, "获取验证码" + _toDisplayString(_ctx.setCodeLeftTime > 0 ? "（" + _ctx.setCodeLeftTime + "）" : ""), 3)
              ]),
              (_ctx.errorData.validCode)
                ? (_openBlock(), _createBlock("span", _hoisted_26, "请输入验证码"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("label", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "inviteCode",
                  class: "value",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.inviteCode = $event)),
                  placeholder: "选填"
                }, null, 512), [
                  [_vModelText, _ctx.inviteCode]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", {
              class: "reg-btn",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
            }, "注册")
          ])
        ])
      ])
    ])
  ]))
}